import {Modal, Spin} from 'antd'
import React, {useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import Api from "../../services/Api";
import HelperGeneral from "../../helpers/HelperGeneral";
import ReactHtmlParser from "react-html-parser";

const KvkkModal = (props) => {
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false);
    const [informationData, setInformationData] = useState([]);

    useEffect(() => {
        if (props.kvkkType !== null) {
            setOpen(true)
            getInformation();
        }
    }, [props])

    const getInformation = () => {
        setLoading(true);
        Api.getOtherPages().then((e) => {
            setLoading(false);
            setInformationData(e?.data);
        }).catch(e => {
            HelperGeneral.alert(e);
            setLoading(false);
        })
    }

    let title = ''
    if (props.kvkkType === 'kvkk_1') title = 'Kullanıcı Sözleşmesi';
    else if (props.kvkkType === 'kvkk_2') title = 'Aydınlatma Metni';
    else if (props.kvkkType === 'kvkk_3') title = 'Açık Rıza Beyanı';
    else if (props.kvkkType === 'kvkk_4') title = 'Ticari Elektronik İleti Bilgilendirme Metni';

    return (
        <>
            <Modal
                visible={open}
                title={title}
                cancelButtonProps={{style: {display: 'none'}}}
                okText={'Okudum, Anladım'}
                onOk={() => {
                    setOpen(false)
                    props.selectedKvkk(null)
                }}
                onCancel={() => {
                    setOpen(false)
                    props.selectedKvkk(null)
                }}
                keyboard={false}
                centered
                width={650}
                bodyStyle={{overflowY: 'auto', maxHeight: 'calc(100vh - 200px)'}}
            >
                <Spin spinning={loading}>
                    {
                        props.kvkkType === 'kvkk_1' && (
                            informationData?.find((data) => data?.id === 38)?.description ? ReactHtmlParser(informationData?.find((data) => data?.id === 38)?.description) : ''
                        )
                    }
                    {
                        props.kvkkType === 'kvkk_2' && (
                            informationData?.find((data) => data?.id === 27)?.description ? ReactHtmlParser(informationData?.find((data) => data?.id === 27)?.description) : ''
                        )
                    }
                    {
                        props.kvkkType === 'kvkk_3' && (
                            informationData?.find((data) => data?.id === 28)?.description ? ReactHtmlParser(informationData?.find((data) => data?.id === 28)?.description) : ''
                        )
                    }
                    {
                        props.kvkkType === 'kvkk_4' && (
                            informationData?.find((data) => data?.id === 37)?.description ? ReactHtmlParser(informationData?.find((data) => data?.id === 37)?.description) : ''
                        )
                    }
                </Spin>
            </Modal>
        </>
    )
}

export default withRouter(KvkkModal)


